import { nentralConfByDomain } from '@/api/system/nutral'
const user = {
  state: {
    hasNeuTralConfig: false,
    alreadyGet: false,
    loginTitle: '', //登录标题
    loginLogo: '', //登录logo
    loginLogoUrl: '', //登录外连接
    loginImg: '', //登录背景图
    copyright: '', //备案
    recordNumber: '', //版权号
    screenTitle: '', //大屏标题
    screenLogo: '', //大屏logo
    consoleTitle: '', //控制台标题
    consoleLogo: '', //控制台logo
    helpDocumentPc: '', //pc帮助文档
    helpDocumentApp: '' //app帮助文档
  },

  mutations: {
    SET_NEUTRALCONFIG: (state) => {
      //是否有中性配置
      state.hasNeuTralConfig = true
    },
    SET_ALREADYGET: (state) => {
      //是否已经获取过中性配置
      state.alreadyGet = true
    },
    SET_LOGINTITLE: (state, loginTitle) => {
      state.loginTitle = loginTitle
    },
    SET_LOGINLOGO: (state, loginLogo) => {
      state.loginLogo = loginLogo
    },
    SET_LOGINLOGOURL: (state, loginLogoUrl) => {
      state.loginLogoUrl = loginLogoUrl
    },
    SET_LOGINIMG: (state, loginImg) => {
      state.loginImg = loginImg
    },
    SET_COPYRIGHT: (state, copyright) => {
      state.copyright = copyright
    },
    SET_RECORDNUMBER: (state, recordNumber) => {
      state.recordNumber = recordNumber
    },
    SET_SCREENTITLE: (state, screenTitle) => {
      state.screenTitle = screenTitle
    },
    SET_SCREENLOGO: (state, screenLogo) => {
      state.screenLogo = screenLogo
    },
    SET_CONSOLETITLE: (state, consoleTitle) => {
      state.consoleTitle = consoleTitle
    },
    SET_CONSOLELOGO: (state, consoleLogo) => {
      state.consoleLogo = consoleLogo
    },
    SET_HELPDOCUMENTPC: (state, helpDocumentPc) => {
      state.helpDocumentPc = helpDocumentPc
    },
    SET_HELPDOCUMENTAPP: (state, helpDocumentApp) => {
      state.helpDocumentApp = helpDocumentApp
    }
  },

  actions: {
    // 获取中性配置
    GetConfig({ commit }, domain) {
      return new Promise((resolve, reject) => {
        nentralConfByDomain({
          domainName: domain
        })
          .then((res) => {
            if (res.code == 200) {
              commit('SET_ALREADYGET')
              if (res.data) {
                commit('SET_NEUTRALCONFIG')
                commit('SET_LOGINTITLE', res.data.loginTitle)
                commit('SET_LOGINLOGO', res.data.loginLogo)
                commit('SET_LOGINLOGOURL', res.data.loginLogoUrl)
                commit('SET_LOGINIMG', res.data.loginImg)
                commit('SET_COPYRIGHT', res.data.copyright)
                commit('SET_RECORDNUMBER', res.data.recordNumber)
                commit('SET_SCREENTITLE', res.data.screenTitle)
                commit('SET_SCREENLOGO', res.data.screenLogo)
                commit('SET_CONSOLETITLE', res.data.consoleTitle)
                commit('SET_CONSOLELOGO', res.data.consoleLogo)
                commit('SET_HELPDOCUMENTPC', res.data.helpDocumentPc)
                commit('SET_HELPDOCUMENTAPP', res.data.helpDocumentApp)
              }
              resolve(res.data)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}

export default user
